/**
 * @generated SignedSource<<9b38f4136c7896b95bed9fc496077f30>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type pantoneLibraryPageImportDefaultPaletteMutation$variables = {
  id: string;
};
export type pantoneLibraryPageImportDefaultPaletteMutation$data = {
  readonly importDefaultPalette: string;
};
export type pantoneLibraryPageImportDefaultPaletteMutation = {
  response: pantoneLibraryPageImportDefaultPaletteMutation$data;
  variables: pantoneLibraryPageImportDefaultPaletteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "importDefaultPalette",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pantoneLibraryPageImportDefaultPaletteMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "pantoneLibraryPageImportDefaultPaletteMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "fa7d6ee60085364e86a76ec72be437c1",
    "id": null,
    "metadata": {},
    "name": "pantoneLibraryPageImportDefaultPaletteMutation",
    "operationKind": "mutation",
    "text": "mutation pantoneLibraryPageImportDefaultPaletteMutation(\n  $id: ID!\n) {\n  importDefaultPalette(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "b27cb8b55b263caba57c5e9749898e64";

export default node;
